import { render } from "./document_management.html?vue&type=template&id=4f39d920&external"
import script from "./document_management.js?vue&type=script&lang=js&external"
export * from "./document_management.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__